import type { ReplicantErrorCode, ReplicantErrorSubCode } from '../Errors';

const STATUS_DESCRIPTIONS = { 400: 'Bad Request', 404: 'Not Found', 429: 'Too Many Requests' };

export class APIError extends Error {
    status?: { statusCode: number; statusDescription: string };

    constructor(message: string, status?: { statusCode: number; statusDescription: string } | 400 | 404 | 429) {
        super(message);

        if (typeof status === 'number') {
            this.status = { statusCode: status, statusDescription: STATUS_DESCRIPTIONS[status] };
        } else {
            this.status = status;
        }
    }

    static withCode(message: string, code: ReplicantErrorCode, subCode: ReplicantErrorSubCode | undefined): APIError {
        return new this(JSON.stringify({ message, code, subCode }));
    }
}
